// extracted by mini-css-extract-plugin
export default {"heading":"dt-z","corrected":"et-z","redirectVerbiageContainer":"ft-z","redirectVerbiageText":"gt-z"};